import { useMutation, useQueryClient } from '@tanstack/react-query';
import { activityApi } from '@/services/adminApi';
import { queryKeys } from '@/utils/queryKeys';
import type { CreateActivityFormData } from '@/types/activity';

export function useUpdateActivity(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateActivityFormData) => 
      activityApi.updateActivity(id, data),
    
    onSuccess: () => {
      // Invalidate and refetch activity details
      queryClient.invalidateQueries({ 
        queryKey: queryKeys.activities.detail(id) 
      });
      
      // Invalidate activities list to show updated data
      queryClient.invalidateQueries({ 
        queryKey: queryKeys.activities.lists() 
      });
    },
  });
}
